import api from "api";

const participants = {
    list: (slug, page, params) => {
        return api().get(`/events/detail/${slug}/participants?page=${page}`, {params: params})
    },
    
    /**
     * `filters` são os mesmos parâmetros usados em `list`. O endpoint ainda não
     * os aplica — comparando a resposta com e sem parâmetros, o CSV volta
     * idêntico — mas são enviados para que a exportação passe a respeitar os
     * filtros assim que o backend der suporte, sem mudança no front.
     *
     * `fields`, quando informado, é a lista ordenada das chaves de campo
     * (fixos + `custom_<id>`) a incluir no arquivo. Omitido/vazio, o backend
     * exporta todos os campos na ordem padrão.
     */
    download: (eventId, filters = {}, fields = null) => {
        const params = { event_id: eventId, ...filters };
        if (fields && fields.length > 0) params.fields = fields;

        return api().get('/exports/participants',
        {
            params,
            headers: {
                'Accept': 'text/csv',
                'Content-Type': 'text/csv'
            },
        }
        )
    }
}

export default participants;